import { useState, useEffect } from 'react'
import axios from 'axios'
import { Link, useLocation } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useDispatch } from 'react-redux'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import { matchConsumerId } from '../../utility'
import { KTSVG } from '../../../../_metronic/helpers'
import { NotificationManager } from 'react-notifications'
const fileDownload = require('js-file-download')

export function SSHAPI() {
  const [data, setData] = useState('')
  const [copiedStates, setCopiedStates] = useState({
    domain: false,
    consumerId: false
  })
  const [showModal, setShowModal] = useState(false)
  const [activeTab, setActiveTab] = useState('nodejs')
  const [copiedCode, setCopiedCode] = useState(false)
  
  const query = useLocation()
  const dispatch = useDispatch()
  const location = query.search || ''
  const Id = location.split('=')[1]
  
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any
  const {
    user: {consumerId, domain},
  } = user

  useEffect(() => {
    if (consumerId) {
      matchConsumerId(consumerId, dispatch, auth)
    }
  }, [consumerId])

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/get-ssh-pair/${Id}`)
      .then((response) => {
        if (response.data.consumer) {
          setData(response.data.consumer.publicKey)
        } else {
          window.location.href = `/dashboard`
        }
      })
  }, [Id])

  const handleCopy = (text: string, type: 'domain' | 'consumerId') => {
    navigator.clipboard.writeText(text)
    setCopiedStates(prev => ({ ...prev, [type]: true }))
    NotificationManager.success(`${type === 'consumerId' ? 'Consumer ID' : 'Domain'} copied to clipboard!`, '', 3000)
    setTimeout(() => {
      setCopiedStates(prev => ({ ...prev, [type]: false }))
    }, 2000)
  }

  const handleCopyCode = (code: string) => {
    navigator.clipboard.writeText(code)
    setCopiedCode(true)
    NotificationManager.success('Code copied to clipboard!', '', 3000)
    setTimeout(() => {
      setCopiedCode(false)
    }, 2000)
  }

  const onSubmit = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL_BACKEND_LOCAL}/generate-api-key/${Id}`)
      .then((response) => {
        fileDownload(response.data.privateKeyContent, 'cm-api-key.pem')
        setShowModal(false)
        NotificationManager.success('API key downloaded successfully!', '', 3000)
      })
      .catch((error) => {
        let errorMessage = 'Failed to generate API key';
        let url = 'https://appointments.nanothread.io/clanmeeting/demo';

        if (error.response && error.response.data && error.response.data.msg) {
          errorMessage = error.response.data.msg;
        }
        setShowModal(false);
        if (errorMessage.startsWith('Sorry')) {
          url = 'https://clanmeeting.com/contact-us';
        }
        NotificationManager.error(
          errorMessage,
          '',
          20000,
          () => {
            window.location.href = url;
          }
        );
      })
  }

  const codeSnippets = {
    nodejs: `// npm install jsonwebtoken
// Refer: https://github.com/auth0/node-jsonwebtoken

const jwt = require("jsonwebtoken");
const fs = require("fs");

const header = {
  keyid: "${consumerId || 'your-consumer-id'}",
  algorithm: "RS256"
}

const payLoad = {
  sub: "${consumerId || 'your-consumer-id'}",
  aud: "clanmeeting",
  iss: "production",
  // TODO: Specify meeting room name or put "*" to generate JWT for any room name
  room: "specify-room-name-here",
  exp: Math.floor(Date.now() / 1000) + (60 * 15), // token will be valid for 15 minutes
  nbf: Math.floor(Date.now() / 1000),
  context: {},
}

// TODO: Set the path to the API key
const signature = fs.readFileSync('/path/to/cm-api-key.pem');
const token = jwt.sign(payLoad, signature, header);

console.log(token);`,

    php: `# Refer: https://github.com/firebase/php-jwt
# Use composer to manage your dependencies and download PHP-JWT:
# composer require firebase/php-jwt
# Optionally, install the paragonie/sodium_compat package from composer if your php is < 7.2 or does not have libsodium installed:
# composer require paragonie/sodium_compat

use Firebase\\JWT\\JWT;

$now = time();
$expiry_in_seconds = 60 * 15; // token will be valid for the next 15 minutes

$header = "${consumerId || 'your-consumer-id'}";

$payload = array(
    "sub"=> "${consumerId || 'your-consumer-id'}",
    "aud"=> "clanmeeting",
    "iss"=> "production",
    // TODO: Specify meeting room name or put "*" to generate JWT for any room name
    "room"=> "specify-room-name-here",    
    "exp"=> $now + $expiry_in_seconds,
    "nbf"=> $now,
    "context"=> array()
);

// TODO: Set the path to the API key
$private_key_file = url("/path/to/cm-api-key.pem");

$signature = openssl_pkey_get_private(
    file_get_contents($private_key_file)
);

$token = JWT::encode($payload, $signature, "RS256", $header);

echo $token;`,

    python: `# Refer: https://pyjwt.readthedocs.io/en/stable/usage.html#encoding-decoding-tokens-with-rs256-rsa
# pip install pyjwt
# pip install pyjwt[crypto]

import jwt
import datetime

header = {"kid": "${consumerId || 'your-consumer-id'}"}

now = datetime.datetime.utcnow()

payload = {
    "sub": "${consumerId || 'your-consumer-id'}",
    "aud": "clanmeeting",
    "iss": "production",
    // TODO: Specify meeting room name or put "*" to generate JWT for any room name
    "room": "specify-room-name-here",
    "exp": now + datetime.timedelta(seconds=900), # e.g. User should login within the next 15 minutes.
    "nbf": now,
    "context": {}
}

// TODO: Set the path to the API key
with open('/path/to/cm-api-key.pem','r') as file:
    signature = file.read()

token = jwt.encode(payload, signature, algorithm="RS256", headers=header)

print(token)`,

    ruby: `# Refer: https://github.com/jwt/ruby-jwt
# Rubygems:
# gem install jwt
# Bundler:
# Add the following to your Gemfile
# gem 'jwt' and run bundle install

consumer_id = "${consumerId || 'your-consumer-id'}"

# Header
header = {
  kid: consumer_id,
  alg: 'RS256'
}

# Payload
payload = {
  sub: consumer_id,
  aud: 'clanmeeting',
  iss: 'production',
  // TODO: Specify meeting room name or put "*" to generate JWT for any room name
  room: 'specify-room-name-here',
  exp: Time.now.to_i + (60 * 15), # Token valid for 15 minutes
  nbf: Time.now.to_i,
  context: {}
}

# TODO: Set the path to the API key
private_key_path = '/path/to/cm-api-key.pem'
private_key = OpenSSL::PKey::RSA.new(File.read(private_key_path))

# Generate JWT
token = JWT.encode(payload, private_key, 'RS256', header)

puts token
`,

    java: `// Refer for installation: https://github.com/auth0/java-jwt

import com.auth0.jwt.JWT;
import com.auth0.jwt.algorithms.Algorithm;

import java.io.IOException;
import java.nio.file.Files;
import java.nio.file.Paths;
import java.security.interfaces.RSAPrivateKey;
import java.security.spec.PKCS8EncodedKeySpec;
import java.security.KeyFactory;
import java.util.Base64;
import java.util.Date;
import java.util.HashMap;
import java.util.Map;

public class GenerateJWT {

    public static void main(String[] args) throws Exception {
        String consumerId = "${consumerId || 'your-consumer-id'}"

        // TODO: Edit path to your API Key
        String privateKeyPath = "/path/to/cm-api-key.pem";

        // Load private key
        RSAPrivateKey privateKey = loadPrivateKey(privateKeyPath);

        // Set JWT header
        Map<String, Object> header = new HashMap<>();
        header.put("kid", consumerId);
        header.put("alg", "RS256");

        // Current time
        long nowMillis = System.currentTimeMillis();
        long expMillis = nowMillis + (15 * 60 * 1000); // 15 minutes

        // Build token
        String token = JWT.create()
                .withHeader(header)
                .withSubject(consumerId)
                .withAudience("clanmeeting")
                .withIssuer("production")
                // TODO: Specify meeting room name or put "*" to generate JWT for any room name
                .withClaim("room", "specify-room-name-here") // or "*"
                .withClaim("context", new HashMap<>()) // empty context object
                .withIssuedAt(new Date(nowMillis))
                .withNotBefore(new Date(nowMillis))
                .withExpiresAt(new Date(expMillis))
                .sign(Algorithm.RSA256(null, privateKey));

        System.out.println(token);
    }

    private static RSAPrivateKey loadPrivateKey(String filePath) throws Exception {
        String key = new String(Files.readAllBytes(Paths.get(filePath)))
                .replaceAll("-----BEGIN (.*)-----", "")
                .replaceAll("-----END (.*)-----", "")
                .replaceAll("\\s", "");

        byte[] keyBytes = Base64.getDecoder().decode(key);
        PKCS8EncodedKeySpec spec = new PKCS8EncodedKeySpec(keyBytes);
        KeyFactory kf = KeyFactory.getInstance("RSA");
        return (RSAPrivateKey) kf.generatePrivate(spec);
    }
}`,

    go: `// go get github.com/golang-jwt/jwt/v5

package main

import (
    "crypto/rsa"
    "crypto/x509"
    "encoding/pem"
    "fmt"
    "os"
    "time"
    "github.com/golang-jwt/jwt/v5"
)

func main() {
    // Get consumer ID from environment or default
    consumerID := "${consumerId || 'your-consumer-id'}"

    // TODO: Edit path to your API Key
    privateKeyPath := "/path/to/cm-api-key.pem"

    privateKey, err := loadPrivateKeyPKCS8(privateKeyPath)
    if err != nil {
        panic(fmt.Errorf("failed to load private key: %w", err))
    }

    // Current time and expiration (15 minutes)
    now := time.Now()
    expiration := now.Add(15 * time.Minute)

    // Build claims
    claims := jwt.MapClaims{
        "sub":     consumerID,
        "aud":     "clanmeeting",
        "iss":     "production",
        // TODO: Specify meeting room name or put "*" to generate JWT for any room name
        "room":    "specify-room-name-here",
        "exp":     expiration.Unix(),
        "nbf":     now.Unix(),
        "context": map[string]interface{}{},
    }

    // Create token with RS256 header
    token := jwt.NewWithClaims(jwt.SigningMethodRS256, claims)
    token.Header["kid"] = consumerID
    token.Header["alg"] = "RS256"

    // Sign token
    signedToken, err := token.SignedString(privateKey)
    if err != nil {
        panic(fmt.Errorf("failed to sign JWT: %w", err))
    }

    fmt.Println(signedToken)
}

// loadPrivateKeyPKCS8 loads an RSA private key in PKCS#8 PEM format
func loadPrivateKeyPKCS8(filePath string) (*rsa.PrivateKey, error) {
    keyData, err := os.ReadFile(filePath)
    if err != nil {
        return nil, err
    }

    block, _ := pem.Decode(keyData)
    if block == nil {
        return nil, fmt.Errorf("no PEM block found in %s", filePath)
    }

    key, err := x509.ParsePKCS8PrivateKey(block.Bytes)
    if err != nil {
        return nil, fmt.Errorf("failed to parse PKCS#8 private key: %v", err)
    }

    rsaKey, ok := key.(*rsa.PrivateKey)
    if !ok {
        return nil, fmt.Errorf("private key is not RSA")
    }

    return rsaKey, nil
}`,

    other: `// RS256 algorithm should be supported by the library used to generate JWT.
// Refer: https://jwt.io/#libraries-io`,
  }

  const tabs = [
    { id: 'nodejs', label: 'Node.js', icon: '⬢' },
    { id: 'php', label: 'PHP', icon: '🐘' },
    { id: 'python', label: 'Python', icon: '🐍' },
    { id: 'ruby', label: 'Ruby', icon: '💎' },
    { id: 'java', label: 'Java', icon: '☕' },
    { id: 'go', label: 'Go', icon: '🔵' },
    { id: 'other', label: 'Other', icon: '</>' }
  ]

  return (
    <div className='container py-8'>
      <style>{`
        .brand-card {
          background-color: #333;
          border: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .brand-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(97, 78, 110, 0.2);
        }

        .copy-btn {
          background-color: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.3);
          transition: background-color 0.2s ease;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .copy-btn svg {
          fill: white !important;
          stroke: white !important;
        }

        .btn .svg-icon {
          margin: 0 !important;
        }

        .copy-btn:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }

        .copy-btn.copied {
          background-color: rgba(34, 197, 94, 0.3);
          border-color: rgba(34, 197, 94, 0.5);
        }

        .code-box {
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: none !important;
        }

        .btn-brand {
          background-color: #614e6e;
          color: white;
          border: none;
          transition: background-color 0.2s ease;
          margin-top:10px;
        }

        .btn-brand:hover {
          background-color: #4f3e5a;
          color: white;
        }

        .btn-brand:disabled {
          background-color: #8a7a94;
          opacity: 0.6;
        }

        .btn-outline-brand {
          background-color: transparent;
          border: 2px solid #614e6e;
          color: #614e6e;
          transition: all 0.2s ease;
        }

        .btn-outline-brand:hover {
          background-color: #614e6e;
          color: white;
        }

        .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1040;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-content-custom {
          background-color: white;
          border-radius: 8px;
          max-width: 600px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }

        .info-text {
          color: #6c757d;
          line-height: 1.6;
        }

        .info-text a {
          color: #614e6e;
          text-decoration: none;
          font-weight: 600;
        }

        .info-text a:hover {
          text-decoration: underline;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 8px 16px;
          background-color: #d4edda;
          border: 1px solid #28a745;
          border-radius: 6px;
          color: #155724;
          font-weight: 600;
          font-size: 14px;
          margin-top: -10px;
          margin-right: -10px;
        }

        .status-badge svg {
          margin-right: 8px;
        }

        .code-tab-container {
          background-color: #1e1e1e;
          border-radius: 8px;
          overflow: hidden;
        }

        .code-tabs {
          display: flex;
          background-color: #2d2d2d;
          border-bottom: 2px solid #3d3d3d;
          overflow-x: auto;
          flex-wrap: wrap;
        }

        .code-tab {
          padding: 12px 24px;
          background: none;
          border: none;
          color: #aaa;
          cursor: pointer;
          transition: all 0.2s ease;
          font-weight: 500;
          white-space: nowrap;
          border-bottom: 2px solid transparent;
          margin-bottom: -2px;
        }

        .code-tab:hover {
          color: #fff;
          background-color: rgba(255, 255, 255, 0.05);
        }

        .code-tab.active {
          color: #fff;
          border-bottom-color: #614e6e;
          background-color: #1e1e1e;
        }

        .code-content {
          position: relative;
          padding: 24px;
          background-color: #1e1e1e;
          max-height: 500px;
          overflow-y: auto;
        }

        .code-content pre {
          margin: 0;
          color: #d4d4d4;
          font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
          font-size: 14px;
          line-height: 1.6;
          white-space: pre-wrap;
          word-break: break-word;
        }

        .copy-code-btn {
          position: absolute;
          top: 16px;
          right: 16px;
          background-color: #614e6e;
          border: none;
          color: white;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          font-size: 13px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .copy-code-btn:hover {
          background-color: #4f3e5a;
        }

        .copy-code-btn.copied {
          background-color: #28a745;
        }

        .code-info {
          background-color: rgba(97, 78, 110, 0.1);
          border-left: 4px solid #614e6e;
          padding: 16px;
          margin-top: 16px;
          border-radius: 4px;
        }

        .test-mode-link {
          background-color: #fff3cd;
          border: 1px solid #ffc107;
          border-radius: 8px;
          padding: 16px 20px;
          display: inline-flex;
          align-items: center;
          text-decoration: none;
          color: #856404;
          font-weight: 600;
          transition: all 0.2s ease;
        }

        .test-mode-link:hover {
          background-color: #ffc107;
          color: #856404;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
          text-decoration: none;
        }
      `}</style>

      <div className='d-flex justify-content-between align-items-start mb-4 flex-wrap gap-3'>
        <div>
          <PageTitle breadcrumbs={[]}>Production API Keys</PageTitle>
          <h4>Generate Secure JWTs Using API Key</h4>
        </div>
        <div className='status-badge'>
          <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
            <rect x='3' y='11' width='18' height='11' rx='2' ry='2'/>
            <path d='M7 11V7a5 5 0 0 1 10 0v4'/>
          </svg>
          Production Mode
        </div>
      </div>

      <div className='row g-4'>
        {/* Domain Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex justify-content-between align-items-start mb-4'>
              <div>
                <h5 className='text-white mb-2 fw-bold'>Domain</h5>
                <p className='text-white-50 mb-0'>Your API domain endpoint</p>
              </div>
              <button
                className={`copy-btn btn btn-sm rounded-circle ${copiedStates.domain ? 'copied' : ''}`}
                onClick={() => handleCopy(domain, 'domain')}
              >
                <KTSVG path='/media/icons/duotune/files/fil026.svg' className='svg-icon-2' />
              </button>
            </div>
            <div className='code-box rounded-2 p-4'>
              <code className='text-white fs-6 d-block' style={{wordBreak: 'break-all'}}>{domain}</code>
            </div>
          </div>
        </div>

        {/* Consumer ID Card */}
        <div className='col-lg-6 col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex justify-content-between align-items-start mb-4'>
              <div>
                <h5 className='text-white mb-2 fw-bold'>Consumer ID</h5>
                <p className='text-white-50 mb-0'>Your unique identifier</p>
              </div>
              <button
                className={`copy-btn btn btn-sm rounded-circle ${copiedStates.consumerId ? 'copied' : ''}`}
                onClick={() => handleCopy(location.split('=')[1] || 'test123', 'consumerId')}
              >
                <KTSVG path='/media/icons/duotune/files/fil026.svg' className='svg-icon-2' />
              </button>
            </div>
            <div className='code-box rounded-2 p-4'>
              <code className='text-white fs-6'>{location.split('=')[1] || 'test123'}</code>
            </div>
          </div>
        </div>

        {/* Generate API Key Card */}
        <div className='col-12'>
          <div className='brand-card card rounded-3 p-6 shadow-sm'>
            <div className='d-flex align-items-start mb-4'>
              <div className='flex-grow-1'>
                <h5 className='text-white fw-bold mb-3'>Your API Key (Private SSH Key File)</h5>
                <p className='text-white-50 mb-4'>
                  Download your private API Key to generate JWTs programmatically. This key allows you to create secure, short-lived tokens for production use instead of the static test JWT.
                </p>
                <div className='alert alert-warning mb-4' role='alert'>
                  <strong>⚠️ Important:</strong> Generating a new key will immediately invalidate your existing key and all JWTs created with it. Keep this key confidential.
                </div>
                <button
                  type='button'
                  className='btn-brand btn btn-lg px-5 py-3 fw-semibold'
                  onClick={() => setShowModal(true)}
                >
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/>
                    <polyline points='7 10 12 15 17 10'/>
                    <line x1='12' y1='15' x2='12' y2='3'/>
                  </svg>
                  Generate & Download API Key
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Code Snippets Section */}
        <div className='col-12'>
          <div className='card rounded-3 shadow-sm' style={{border: '1px solid #e9ecef'}}>
            <div className='p-6'>
              <div className='d-flex align-items-start mb-4'>
                <div>
                  <h5 className='fw-bold mb-2' style={{color: '#333'}}>Generate JWTs Programmatically</h5>
                  <p className='info-text mb-0'>
                    Use these code snippets to generate JWTs in your application. Your domain and consumer ID are pre-filled.
                    Don't forget to update the path to your downloaded API key file. Finally, pass the JWT into the `jwt` property.
                  </p>
                </div>
              </div>

              <div className='code-tab-container'>
                <div className='code-tabs'>
                  {tabs.map(tab => (
                    <button
                      key={tab.id}
                      className={`code-tab ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <span className='me-2'>{tab.icon}</span>
                      {tab.label}
                    </button>
                  ))}
                </div>

                <div className='code-content'>
                  <button
                    className={`copy-code-btn ${copiedCode ? 'copied' : ''}`}
                    onClick={() => handleCopyCode(codeSnippets[activeTab as keyof typeof codeSnippets])}
                  >
                    {copiedCode ? (
                      <>
                        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                          <polyline points='20 6 9 17 4 12'/>
                        </svg>
                        Copied!
                      </>
                    ) : (
                      <>
                        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                          <rect x='9' y='9' width='13' height='13' rx='2' ry='2'/>
                          <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'/>
                        </svg>
                        Copy Code
                      </>
                    )}
                  </button>
                  <pre>{codeSnippets[activeTab as keyof typeof codeSnippets]}</pre>
                </div>
              </div>

              <div className='mt-4 d-flex gap-3 flex-wrap'>
                <a 
                  href='https://clanmeeting.com/docs/video-api-token-generation/sample-jwt/' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='btn btn-outline-brand px-4 py-2'
                >
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/>
                    <polyline points='14 2 14 8 20 8'/>
                  </svg>
                  Sample JWT Structure
                </a>
                <a 
                  href='https://clanmeeting.com/docs/video-api-token-generation/use-jwt-for-login/' 
                  target='_blank' 
                  rel='noopener noreferrer'
                  className='btn btn-outline-brand px-4 py-2'
                >
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/>
                    <polyline points='14 2 14 8 20 8'/>
                  </svg>
                  Using JWT for Authentication
                </a>
                  <a 
                    href='https://clanmeeting.com/docs/video-api-token-generation/generate-jwt' 
                    target='_blank' 
                    rel='noopener noreferrer'
                    className='btn btn-outline-brand px-4 py-2'
                  >
                    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#614e6e' strokeWidth='2' className='me-2'>
                      <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/>
                      <polyline points='14 2 14 8 20 8'/>
                    </svg>
                    View full documentation
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Modal */}
      {showModal && (
        <div className='modal-backdrop-custom' onClick={() => setShowModal(false)}>
          <div className='modal-content-custom' onClick={(e) => e.stopPropagation()}>
            <div className='p-6'>
              <div className='d-flex justify-content-between align-items-center mb-4'>
                <h4 className='fw-bold mb-0'>Generate & Download API Key</h4>
                <button
                  type='button'
                  className='btn btn-sm btn-light rounded-circle'
                  style={{width: '36px', height: '36px', padding: 0}}
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              
              <div className='mb-4'>
                <div className='alert alert-warning d-flex align-items-start' role='alert'>
                  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2 mt-1 flex-shrink-0'>
                    <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'/>
                    <line x1='12' y1='9' x2='12' y2='13'/>
                    <line x1='12' y1='17' x2='12.01' y2='17'/>
                  </svg>
                  <div>
                    <strong>Warning:</strong> Generating a new key will immediately invalidate your existing key and all JWTs created with it.
                  </div>
                </div>
              </div>

              <div className='text-center py-4'>
                <button
                  type='button'
                  className='btn-brand btn btn-lg px-5 py-3 fw-semibold'
                  onClick={onSubmit}
                >
                  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' className='me-2' style={{verticalAlign: 'middle'}}>
                    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/>
                    <polyline points='7 10 12 15 17 10'/>
                    <line x1='12' y1='15' x2='12' y2='3'/>
                  </svg>
                  Download Key
                </button>
              </div>

              <div className='text-end mt-4'>
                <button
                  type='button'
                  className='btn btn-outline-brand px-4 py-2'
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}